module.exports = __webpack_public_path__ + "static/media/success.b5e84b8b.png";